import { Http,Response  } from "@angular/http";
import { HttpClient,  HttpHeaders} from "@angular/common/http";
import { S3Config } from "./s3.config";


declare var CryptoJS: any;

export class S3Uploader {
  private config: S3Config;
  private http: Http;

  init(http: Http, config: S3Config) {
    this.http = http;
    this.config = config;
  }

  upload(file: any): Promise<any> {
    let date = this.generateTimestamp();
    let datetime = date + 'T000000Z';

    let credential = `${this.config.accessKey}/${date}/${this.config.region}/s3/aws4_request`;

    let policy = JSON.stringify({
      "expiration": (new Date(Date.now() + 90000000)).toISOString(),
      "conditions": [
        { "bucket": this.config.bucket },
        ["starts-with", "$key", ""],
        { "acl": "public-read" },
        ["starts-with", "$Content-Type", ""],
        { "x-amz-credential": credential },
        { "x-amz-algorithm": "AWS4-HMAC-SHA256" },
        { "x-amz-meta-uuid": "14365123651274" },
        { "x-amz-date": datetime }
      ]
    });

    let policyBase64 = window.btoa(policy);
    let signatureKey = this.generateSignatureKey(this.config.secretAccessKey, date, this.config.region, "s3");
    let signature = CryptoJS.HmacSHA256(policyBase64, signatureKey).toString(CryptoJS.enc.Hex);

    let formData = new FormData();
    formData.append('acl', "public-read");
    formData.append('key', `raj/test/${file.name}`);
    formData.append('Content-Type', file.type);
    formData.append('X-Amz-Date', datetime);
    formData.append('X-Amz-Algorithm', "AWS4-HMAC-SHA256");
    formData.append('X-Amz-Credential', credential);
    formData.append('X-amz-meta-uuid', "14365123651274");
    formData.append('X-Amz-Signature', signature);
    formData.append('Policy', policyBase64);
    // formData.append('key', file.name);
    formData.append('file', file);

    return new Promise((resolve, reject) => {
      this.http.post(`https://${this.config.bucket}.s3.amazonaws.com/`, formData).subscribe(x => {
      }, x => {
        reject();
      });
    });
  }

  generateSignatureKey(key, dateStamp, regionName, serviceName) {
    let kDate = CryptoJS.HmacSHA256(dateStamp, "AWS4" + key);
    let kRegion = CryptoJS.HmacSHA256(regionName, kDate);
    let kService = CryptoJS.HmacSHA256(serviceName, kRegion);
    let kSigning = CryptoJS.HmacSHA256("aws4_request", kService);

    return kSigning;
  }

  generateTimestamp() {
    let date = new Date();
    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return year + month + day;
  }
}


// WEBPACK FOOTER //
// ./src/app/_services/s3.uploader.ts